module.exports = __webpack_public_path__ + "static/media/11.fbb8bd4f.jpg";